import React from "react";
import {
    Typography,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Button
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import theme from "../../../components/LayoutComponents/theme";
import { deleteMatchRequest } from "../../../remote/usersRequests";

function SkillCard({ index, style, data }) {
    const { session, skills, setSkills, proficiencies, handleProficiencyChange, newlyAddedSkills, setLoading } = data;
    const skill = skills[index];

    const handleDelete = async () => {
        if (
            window.confirm(
                'Are you sure you want to delete this match? This action cannot be undone.'
            )) {
            try {
                setLoading(true)
                let res = await deleteMatchRequest(session?.token, (Number)(skill?.compXwalkId))    
                if (res.data) {
                    alert('Deleted Match')
                    setSkills(res.data || [])
                }
            } catch (e) {
                alert('Delete match failed, try again.')
            }finally{
                setLoading(false)
            }
        }
    }

    if (!skill) return null;

    return (
        <Box
            style={style}
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                boxSizing: "border-box",
                padding: '1rem'
            }}
        >
            <Box
                sx={{
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    backgroundColor: newlyAddedSkills.includes(skill.compXwalkId) ? "lightgreen" : "#fff",
                    padding: 2,
                    boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                }}
            >
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={4}>
                        <Typography fontWeight={500}>
                            {skill.competencyDescription}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        {skill.modified && (
                            <Typography color="error">Proficiency modified!</Typography>
                        )}
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Set Proficiency</InputLabel>
                            <Select
                                value={skill.proficiencyRating ?? 1}
                                label="Set Proficiency"
                                onChange={(e) =>
                                    handleProficiencyChange(
                                        skill.compXwalkId,
                                        skill.competencyId,
                                        parseInt(e.target.value, 10)
                                    )
                                }

                            >
                                {proficiencies.map(
                                    ({ profId, profRating, profDescription }) => (
                                        <MenuItem
                                            key={profId}
                                            value={profRating}
                                            sx={{
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                                transition: "transform 0.15s ease-in-out",
                                                "&:hover": {
                                                    transform: "scale(1.05)",
                                                    backgroundColor: "rgba(0,0,0,0.04)"
                                                }
                                            }}
                                        >
                                            {profDescription}
                                        </MenuItem>
                                    )
                                )}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography fontSize={14}>
                            <strong>Source:</strong>{" "}
                            {skill.originalStatement || "No source provided."}
                        </Typography>
                    </Grid>
                    <Box sx={{ display: 'flex', justifyContent: "flex-end", width: '100%' }}>
                        <Button size="small" sx={{ color: theme.colors.purple }} onClick={handleDelete}>
                            <DeleteIcon />
                        </Button>
                    </Box>
                </Grid>
            </Box>
        </Box>
    );
}

export default React.memo(SkillCard);
